import { useCallback } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { getDashboardDisplayTitle } from '../utils/dashboardDisplayTitle';

/**
 * Returns `(dashboard, whenEmpty?) => string` to unify dashboard titles in the UI.
 */
export function useDashboardDisplayTitle() {
  const { t } = useTranslation('dashboards');

  return useCallback((dashboard, whenEmpty = '') => {
    if (!dashboard) return whenEmpty;
    return getDashboardDisplayTitle(dashboard, t) || whenEmpty;
  }, [t]);
}
